import { useState } from "react";
import { toast } from "sonner";
import { WarningCircle } from "@phosphor-icons/react";
import { api, formatApiError } from "@/lib/api";
import { PIN_RE } from "@/lib/india";

export default function CustomerPinGate({ customerId, onSaved }) {
  const [pin, setPin] = useState("");
  const [saving, setSaving] = useState(false);

  const save = async () => {
    if (!PIN_RE.test(pin)) {
      toast.error("Enter a valid 6-digit PIN code.");
      return;
    }
    setSaving(true);
    try {
      await api.patch(`/customers/${customerId}/pin-code`, { pin_code: pin });
      toast.success("PIN code saved to customer");
      onSaved(pin);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div data-testid="customer-pin-gate" className="border border-amber-400 bg-amber-50 px-3 py-3 space-y-2">
      <div className="flex items-center gap-2 text-amber-800 text-xs font-semibold">
        <WarningCircle size={16} weight="bold" />
        Customer PIN code missing — required before invoicing
      </div>
      <div className="flex flex-wrap gap-2">
        <input
          data-testid="customer-pin-gate-input"
          inputMode="numeric"
          maxLength={6}
          value={pin}
          onChange={(e) => setPin(e.target.value.replace(/\D/g, ""))}
          placeholder="6-digit PIN"
          className="flex-1 min-w-0 w-28 border border-canvas-line bg-white px-3 py-2 font-mono text-sm focus:outline-none focus:border-ink"
        />
        <button
          type="button"
          data-testid="customer-pin-gate-save"
          onClick={save}
          disabled={saving}
          className="px-4 py-2 bg-ink text-white text-xs font-semibold uppercase tracking-wider hover:bg-ink/90 transition-colors disabled:opacity-50"
        >
          {saving ? "Saving…" : "Save PIN"}
        </button>
      </div>
    </div>
  );
}
